import { DfkApi } from './dfk.api.service'

export const getProfiles = async (options, take = 10, skip = 0) => {
    console.log(`Retrieving profile ${skip + 1} - ${skip + take} from the DFK`)

    const { wallets = [] } = options

    let filter = `id_in: [${wallets.map(wallet => `"${wallet}"`)}]`

    let profiles = await getProfilesInternal(filter, '', take, skip)
    console.log(`${profiles.length} profiles retrieved from DKF`)
    return profiles
}

// Retrieve the list of profiles based on the search criteria
const getProfilesInternal = async (filter, customProperties = '', take = 1, skip = 0) => {
    const allProperties = `
	id
    name
    picId
    nftId
    picUri
    collectionId`

    // Query to retrieve a single hero based on their id
    const query = `
	{
		profiles(
			first: ${take}
			skip: ${skip}
			where:{
			  ${filter}
			}
		)
		{
			${allProperties}
			${customProperties}
		}
	}`

    const result = await DfkApi.get(query)
    return result.profiles
}
